import React from 'react'
import { Grid, Button, Popup, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';

import Labels from './../../../../common/Labels'
import { DateTime } from "luxon";
import momentDateAndTime from './../../../../../helpers/momentDateAndTime'

const dayFlags = [false, true, true, true, true, true, false];

const getWorkingDaysBetween = function (startDate, endDate) {
    if (startDate < endDate) {
        return -1
    }
    let totalWorkingDays = 0;

    while (startDate > endDate) {
        endDate = endDate.plus({ days: 1 });
        const weekDay = endDate.weekday;
        if (dayFlags[weekDay - 1]) {
            totalWorkingDays++;
        }
    }

    return totalWorkingDays;
}

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {
        let selectedData = this.props.selectedDataById;
        const workSpaceTimeZone = selectedData.timeZone;
        const asd = DateTime.fromISO(selectedData.actualStartDate).setZone(workSpaceTimeZone).startOf('day');
        const aed = DateTime.fromISO(selectedData.actualEndDate).setZone(workSpaceTimeZone).endOf('day');
        const sd = DateTime.fromISO(selectedData.startDate).setZone(workSpaceTimeZone).startOf('day');
        const ed = DateTime.fromISO(selectedData.endDate).setZone(workSpaceTimeZone).endOf('day');

        const daysBetweenStartToday = getWorkingDaysBetween(asd, sd);
        const daysBetweenTodayEnd = getWorkingDaysBetween(aed, ed);
        let daysDiffActStartActEnd = getWorkingDaysBetween(aed, asd);
        
        Number(daysDiffActStartActEnd) === 0 ? Number(daysDiffActStartActEnd) + 1 : daysDiffActStartActEnd

        return (
            <Grid >
                <Grid.Row style={{ margin: '0 0 20px 0' }}>
                    <Grid.Column width={6} className="commanLabel">
                        <Labels
                            name="Start Date"
                            text={<span>
                                {momentDateAndTime(selectedData.actualStartDate)}  &nbsp;
                                {daysBetweenStartToday > 0 ?
                                    <span className="f_9">Delayed by {daysBetweenStartToday} days &nbsp;
                                    < Popup
                                            className="popupStyled"
                                            inverted
                                            trigger={<Icon name="info circle" />}
                                            flowing
                                            hoverable
                                        >Estimated Start Date was {momentDateAndTime(selectedData.startDate)}
                                        </Popup></span> : ""}
                            </span>}
                        />
                    </Grid.Column>
                    <Grid.Column width={6} className="commanLabel"  >
                        <Labels
                            name="Total Working Days"
                            text={
                                <span>
                                    {daysDiffActStartActEnd === 0 ? 1 : daysDiffActStartActEnd}  &nbsp;
                                    {daysDiffActStartActEnd > selectedData.totaldays ?
                                        <span className="f_9">Delayed by {daysDiffActStartActEnd - selectedData.totaldays} {daysDiffActStartActEnd - selectedData.totaldays === 1 ? "day" : "days"} &nbsp;
                                        <Popup
                                                className="popupStyled"
                                                inverted
                                                trigger={<Icon name="info circle" />}
                                                flowing
                                                hoverable
                                            >Estimated Working Days were {selectedData.totaldays}
                                            </Popup></span> : ""}
                                </span>
                            }
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Labels
                            name="Contingency / Holidays"
                            text={selectedData && selectedData.contingency === 0 ? 0 : selectedData.contingency}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={6} className="commanLabel">
                        <Labels
                            name="End Date"
                            text={<span>
                                {momentDateAndTime(selectedData.actualEndDate)}  &nbsp;
                                {daysBetweenTodayEnd > 0 ?
                                    <span className="f_9">Delayed by {daysBetweenTodayEnd} days &nbsp;
                                    <Popup className="popupStyled"
                                            inverted
                                            trigger={<Icon name="info circle" />}
                                            flowing
                                            hoverable >
                                            Estimated End Date was {momentDateAndTime(selectedData.endDate)}
                                        </Popup>
                                    </span> : ""}
                            </span>}
                        />
                    </Grid.Column>
                    <Grid.Column width={10} >
                        <Labels
                            name="Working Days"
                            text={<div className="days_buttons">
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[0] ? "bg-blue" : ""}`} disabled >Su</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[1] ? "bg-blue" : ""}`} disabled >Mo</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[2] ? "bg-blue" : ""}`} disabled >Tu</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[3] ? "bg-blue" : ""}`} disabled >We</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[4] ? "bg-blue" : ""}`} disabled >Th</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[5] ? "bg-blue" : ""}`} disabled >Fr</Button>
                                <Button size='mini' className={` ${this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[6] ? "bg-blue" : ""}`} disabled >Sa</Button>
                            </div>}
                        />
                    </Grid.Column>

                </Grid.Row>
            </Grid>
        )
    }
}

export default Schedule